import type { FC } from 'react'
import { isPresent } from 'ts-extras'
import { cn } from '~/lib'
import { macroPercentage } from '../utils/macros'

export type MacroType = 'protein' | 'carbs' | 'fat' | 'kcal' | 'fiber'

const macroColorClass: Record<MacroType, string> = {
	protein: 'text-macro-protein',
	carbs: 'text-macro-carbs',
	fat: 'text-macro-fat',
	kcal: 'text-macro-kcal',
	fiber: 'text-macro-fiber'
}

export interface MacroCellProps {
	grams: number
	/** Omit weight to calculate percentage */
	weight?: number
	macro: MacroType
}

export const MacroCell: FC<MacroCellProps> = ({ grams, weight, macro }) => {
	const pct = weight ? macroPercentage(grams, weight) : undefined
	const isKcal = macro === 'kcal'
	return (
		<td className="px-2 py-1.5 text-right font-mono text-sm">
			{isPresent(pct) && <span className="text-ink-faint text-xs">{pct.toFixed(0)}% </span>}
			<span className={cn('font-medium', macroColorClass[macro])}>{grams.toFixed(isKcal ? 0 : 1)}</span>
		</td>
	)
}

export function MacroHeader({ macro, label }: { macro: MacroType; label: string }) {
	return <th className={cn('px-2 py-1.5 text-right font-medium text-xs', macroColorClass[macro])}>{label}</th>
}
